import { render, staticRenderFns } from "./CartonTypeModal.vue?vue&type=template&id=9cc08fde&scoped=true"
import script from "./CartonTypeModal.vue?vue&type=script&lang=js"
export * from "./CartonTypeModal.vue?vue&type=script&lang=js"
import style0 from "./CartonTypeModal.vue?vue&type=style&index=0&id=9cc08fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc08fde",
  null
  
)

export default component.exports